import {
  Component,
  ViewChild,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import {
  MAT_DATE_RANGE_SELECTION_STRATEGY,
  DefaultMatCalendarRangeStrategy,
  DateRange,
  MatCalendar,
} from "@angular/material/datepicker";
import { MatMenuTrigger as MatMenuTrigger } from "@angular/material/menu";
import moment from "moment";

@Component({
  selector: "app-date-range-picker",
  templateUrl: "./date-range-picker.component.html",
  styleUrls: ["./date-range-picker.component.scss"],
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: DefaultMatCalendarRangeStrategy,
    },
  ],
  standalone: false,
})
export class DateRangePickerComponent implements OnChanges {
  @ViewChild("start", { static: false }) startCalendar: MatCalendar<Date>;
  @ViewChild("end", { static: false }) endCalendar: MatCalendar<Date>;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  @Input() label = "Date Range";
  @Input() selectedRange?: DateRange<Date>;
  @Output() dateRange: EventEmitter<DateRange<Date>> = new EventEmitter();
  today = new Date();
  startDate = new Date();
  endDate = new Date();

  selectedDateRange: DateRange<Date> = new DateRange(
    this.startDate,
    this.endDate,
  );
  isSelected = true;
  isSameMonth = false;
  viewDateRange: DateRange<Date> = new DateRange(this.startDate, this.endDate);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedRange?.currentValue) {
      const range = changes.selectedRange.currentValue as DateRange<Date>;
      if (range.start && range.end) {
        this.applyDateRange(range.start, range.end);
      }
    }
  }

  _selectStart(date: Date) {
    this.startDate = date;
    this.selectedDateRange = new DateRange(date, this.selectedDateRange.end);
  }

  _selectEnd(date: Date) {
    this.endDate = date;
    this.selectedDateRange = new DateRange(this.selectedDateRange.start, date);
  }

  _selectLastNDays(days: number) {
    const end = new Date();
    const start = moment(end).subtract(days, "days").toDate();
    this.updateCalendars(start, end);
  }

  _selectMTD() {
    const end = new Date();
    const start = moment(end).startOf("month").toDate();
    this.updateCalendars(start, end);
  }

  _selectDateByPeriod(period: any = "months", start: any, end: any) {
    const dateFrom = new Date();
    const startDate = moment(dateFrom)
      .subtract(start, period)
      .startOf("month")
      .toDate();
    const endDate = moment(dateFrom)
      .subtract(end, period)
      .endOf("month")
      .toDate();
    this.updateCalendars(startDate, endDate);
  }

  _selectCustom() {
    this.updateCalendars(this.startDate, this.endDate);
    this.isSameMonth = false;
  }

  updateCalendars(start, end) {
    this.applyDateRange(start, end);
    if (this.startCalendar && this.endCalendar) {
      setTimeout(() => {
        this.startCalendar.activeDate = start;
        this.endCalendar.activeDate = end;
      }, 100);
    }
  }

  setDateRanges() {
    this.viewDateRange = this.selectedDateRange;
    this.dateRange.emit(this.selectedDateRange);
    this.close();
  }

  close() {
    this.trigger.closeMenu();
  }

  /*
   * Check if date range is between the same month
   * to hide second calendar
   */
  checkSameMonth(start, end) {
    const firstDayStart = moment(start)
      .startOf("month")
      .format("YYYY-MM-DD hh:mm");
    const firstDayEnd = moment(end).startOf("month").format("YYYY-MM-DD hh:mm");
    this.isSameMonth = firstDayStart === firstDayEnd;
  }

  private applyDateRange(start: Date, end: Date): void {
    this.startDate = start;
    this.endDate = end;
    this.checkSameMonth(start, end);
    this.selectedDateRange = new DateRange(start, end);
    this.viewDateRange = new DateRange(start, end);
  }
}
